import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { agentTimer } from "../../store/actions/agent.js";
import { formatSeconds } from "./timerHelper.js";

export default function AgentTimer() {
  const dispatch = useDispatch();
  const time = useSelector((state) => state.agent.time); // { seconds, ongoing_timer_id, ... }

  const [seconds, setSeconds] = useState(0);
  const intervalRef = useRef(null);
  const baseRef = useRef(0);
  const startedAtRef = useRef(0);

  useEffect(() => {
    dispatch(agentTimer());
  }, [dispatch]);

  useEffect(() => {
    const serverSeconds = Number(time?.seconds ?? 0);
    const serverNow = time?.now ? new Date(time.now) : null;
    const clientNow = new Date();
    const offsetSec = serverNow ? Math.floor((clientNow - serverNow) / 1000) : 0;
  
    const base = serverSeconds + Math.max(0, offsetSec);
    setSeconds(base);
    baseRef.current = base;
    startedAtRef.current = Date.now();
  }, [time?.seconds, time?.now]);
  
  // ticker (unchanged)
  useEffect(() => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    if (time?.ongoing_timer_id) {
      intervalRef.current = setInterval(() => {
        const elapsed = Math.floor((Date.now() - startedAtRef.current) / 1000);
        setSeconds(baseRef.current + elapsed);
      }, 1000);
    }
    return () => intervalRef.current && clearInterval(intervalRef.current);
  }, [time?.ongoing_timer_id]);
  return <div>{formatSeconds(seconds || 0)}</div>;
}
